import { bl_ppl_to_peppol_submission_queue_RowClass } from '../../../dbschema/bl_ppl_to_peppol_submission_queue.model';
import { BaseContainerModel } from '../../base-container.model';

export class ToPeppolSubmissionQueueContainerModel extends BaseContainerModel {
    bl_ppl_to_peppol_submission_queue: bl_ppl_to_peppol_submission_queue_RowClass = new bl_ppl_to_peppol_submission_queue_RowClass();
}
